import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const openRemoveCardModal = () => openPopupHelper({ popupName: popupNames.REMOVE_CARD });
